// extracted by mini-css-extract-plugin
export var container = "_r-1";
export var copyright = "_r-3";
export var footer = "_r-0";
export var logo = "_r-2";